import { Helmet } from "react-helmet"
import QRCode from "react-qr-code"
import { downloadAppURL } from "../App"

export const currentPath = window.location.pathname
export const currentDomain = window.location.origin

export default function DownloadApp() {
  const handleDownload = () => {
    window.location.href = downloadAppURL
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Android App - FGH - Your One-Stop Gaming Site</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta
          name="description"
          content="Download the FGH Android app to play live blackjack, slots & sports betting anytime. Easy mobile access, fast payouts & GCash/Maya support. 21+ only."
        />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>

      <div className="main-body-content main-container-global-adjusted-padding download-app-content">
        <div className="download-app-content--content">
          <h1>FGH ANDROID APPLICATION</h1>
          <div>
            <p>Scan to Download</p>

            <div
              style={{
                background: "#fff",
                padding: "12px",
                display: "inline-block",
              }}
            >
              <QRCode value={downloadAppURL} size={180} />
            </div>

            <button onClick={handleDownload}>Download App</button>
          </div>
        </div>

        <div className="download-app-content--app">
          <p>
            FGH, your one stop online gaming platform is now available at the
            palm of your hand.
          </p>
          <p>
            Enjoy your favourite games from FGH in fullscreen, directly on your
            mobile device anywhere, anytime. What are you waiting for? Download
            the FGH mobile app now.
          </p>
        </div>
      </div>
    </>
  )
}
